import React from 'react';

type Props = {
  height?: number;
  className?: string;
};

export const VerticalLine = ({ className, height = 12 }: Props) => (
  <svg
    className={className}
    width="12"
    height={height}
    viewBox={`0 0 12 ${height}`}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="0" width="1" height={height} rx="1" />
  </svg>
);
